import {
    Box,
    Flex,
    Text,
    Dialog,
    Button,
} from "@chakra-ui/react";
import {
    useEffect,
    useState,
} from "react";
import {
    useDispatch,
    useSelector,
} from "react-redux";
import { Eye, Download, X, UserPlus } from "lucide-react";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import PageHeader from "../Dashboard/components/PageHeader";
import ReferralStats from "./components/ReferralStats";
import PartnersTable from "./components/PartnersTable";
import ReferralsSkeleton from "./components/ReferralsSkeleton";

import {
    fetchReferredDriversAction,
    fetchReferralMilestonesAction,
    fetchPendingCommissionsAction,
    fetchPartnerPayoutsAction,
} from "../../state/actions/driverPartnerActions";
import {
    fetchResources,
} from "../../state/actions/resourceActions";
import {
    fetchDriverByIdAction,
} from "../../state/actions/driverActions";

import { exportRecruitmentReport } from "../../reports_statements/recruitmentReport";
import ResourceDocumentDialog from "../../components/ResourceDocumentDialog";
import RegisterDriverModal from "../RegisterDriver/RegisterDriverModal";

const Referrals = () => {
    const dispatch = useDispatch();

    const [showSkeleton, setShowSkeleton] = useState(true);

    const {
        driverPartner,
        referredDrivers,
        referralMilestones,
        pendingCommissions,
        partnerPayouts,
        loading,
    } = useSelector(
        state => state.driverPartner
    );
    const {
    resources,
    } = useSelector(
    state => state.resources
     );
     const [isAffidavitOpen, setIsAffidavitOpen] =
    useState(false);
    const [isRegisterOpen, setRegisterOpen] = useState(false);

    useEffect(() => {
        dispatch(fetchReferredDriversAction(1, 10));
        dispatch(fetchReferralMilestonesAction());
        dispatch(fetchPendingCommissionsAction(1, 100));
    }, [dispatch]);
    useEffect(() => {
    dispatch(fetchResources());
}, [dispatch]);
const affidavitResource = resources?.find(
    resource =>
        resource.title ===
        "Mogoma Driver Affidavit Template"
);

const affidavitDocument =
    affidavitResource?.documents?.[0];
const API_URL =
    process.env.REACT_APP_API_BASE_URL?.replace(
        /\/$/,
        ""
    );

const affidavitUrl =
    affidavitDocument?.file_path
        ? `${API_URL}/${affidavitDocument.file_path.replace(
              /^\//,
              ""
          )}`
        : null;
    useEffect(() => {
        if (driverPartner?.driver_partner_id) {
            dispatch(
                fetchPartnerPayoutsAction(
                    driverPartner.driver_partner_id,
                    1,
                    100
                )
            );
        }
    }, [
        dispatch,
        driverPartner?.driver_partner_id,
    ]);

    useEffect(() => {
        referredDrivers
            .filter(
                recruit =>
                    recruit.driver?.driver_id
            )
            .forEach(recruit => {
                dispatch(
                    fetchDriverByIdAction(
                        recruit.driver.driver_id
                    )
                );
            });
    }, [
        referredDrivers,
        dispatch,
    ]);

    // Hide the skeleton only once
   useEffect(() => {
    const timer = setTimeout(() => {
        setShowSkeleton(false);
    }, 3000);

    return () => clearTimeout(timer);
}, []);

    if (showSkeleton) {
        return (
            <Flex
                h="100vh"
                bg="#F8FAFC"
                overflow="hidden"
                  marginBottom={{
        base: 20,
        md: 0,
    }}
            >
                <Box
                    w={{
                        base: 0,
                        md: "280px",
                    }}
                >
                    <Sidebar />
                </Box>

                <Flex
                    flex="1"
                    direction="column"
                >
                    <TopBar />

                    <Box
                        flex="1"
                        overflowY="auto"
                        p={{
                            base: 4,
                            md: 8,
                        }}
                    >
                        <ReferralsSkeleton />
                    </Box>
                </Flex>
            </Flex>
        );
    }
   const canRegisterDriver = 
    driverPartner?.status === "Approved";
    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
               
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="My Recruits"
                        subtitle="Track your recruited drivers, milestone progress, and recruits earnings."
                        secondaryLabel="Driver Affidavit Template"
                        secondaryIcon={Eye}
                        onSecondaryClick={() =>
                            setIsAffidavitOpen(true)
                        }
                        primaryLabel="Register Driver"
                        primaryIcon={UserPlus}
                        onPrimaryClick={() =>
                            setRegisterOpen(true)
                        }
                         primaryDisabled={!canRegisterDriver}

    primaryDisabledTitle="Registration unavailable"

    primaryDisabledMessage={
        "You must be an approved Driver Partner to register drivers."
    }
                    />

                    <ReferralStats
                        drivers={referredDrivers}
                        milestones={referralMilestones}
                        pendingCommissions={pendingCommissions}
                        payouts={partnerPayouts}
                    />

                    <PartnersTable
                        drivers={referredDrivers}
                        milestones={referralMilestones}
                        pendingCommissions={pendingCommissions}
                        payouts={partnerPayouts}
                        loading={loading}
                    />
                    <Dialog.Root
    open={isAffidavitOpen}
    onOpenChange={(e) =>
        setIsAffidavitOpen(e.open)
    }
    size="xl"
>
    <Dialog.Backdrop />

    <Dialog.Positioner>
        <Dialog.Content
            maxW={{
                base: "calc(100vw - 24px)",
                md: "900px",
            }}
            h={{
                base: "90vh",
                md: "85vh",
            }}
            borderRadius="20px"
            overflow="hidden"
        >
            <Dialog.Header
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Box>
                    <Dialog.Title
                        fontSize="lg"
                        fontWeight="700"
                        color="#2453FF"
                    >
                        Mogoma Driver Affidavit Template
                    </Dialog.Title>

                    <Text
                        fontSize="sm"
                        color="gray.500"
                        mt={1}
                    >
                        Review the affidavit template before downloading.
                    </Text>
                </Box>

                <Dialog.CloseTrigger asChild>
                    <Button
                        variant="ghost"
                        size="sm"
                        minW="unset"
                        p={2}
                    >
                        <X size={18} />
                    </Button>
                </Dialog.CloseTrigger>
            </Dialog.Header>

      <Dialog.Body
    p={0}
    flex="1"
    minH={0}
    overflow="auto"
>
    {affidavitUrl ? (
        <Box
            width="100%"
            height="100%"
            minH="600px"
            overflow="auto"
        >
            <iframe
                title="Mogoma Driver Affidavit Template"
                src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
                    affidavitUrl
                )}`}
                width="100%"
                height="100%"
                style={{
                    border: "none",
                    minHeight: "600px",
                }}
            />
        </Box>
    ) : (
        <Flex
            align="center"
            justify="center"
            minH="500px"
        >
            <Text color="gray.500">
                Affidavit template is not available.
            </Text>
        </Flex>
    )}
</Dialog.Body>

            <Dialog.Footer
                borderTop="1px solid"
                borderColor="gray.100"
            >
                <Button
                    variant="outline"
                    onClick={() =>
                        setIsAffidavitOpen(false)
                    }
                >
                    Close
                </Button>

              <Button
    bg="#2453FF"
    color="white"
    _hover={{
        bg: "#1E46D8",
    }}
    disabled={!affidavitUrl}
    onClick={async () => {
        try {
            const response = await fetch(
                affidavitUrl
            );

            const blob =
                await response.blob();

            const url =
                window.URL.createObjectURL(
                    blob
                );

            const link =
                document.createElement("a");

            link.href = url;

            link.download =
                "Mogoma Driver Affidavit Template.docx";

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(
                url
            );
        } catch (error) {
            console.error(
                "Failed to download affidavit:",
                error
            );
        }
    }}
>
    <Download size={17} />
    Download
</Button>
            </Dialog.Footer>
        </Dialog.Content>
    </Dialog.Positioner>
</Dialog.Root>
                </Box>
            </Flex>
            <RegisterDriverModal
            open={isRegisterOpen}
            onClose={() => setRegisterOpen(false)}
            onRegistered={() => {
                dispatch(
                    fetchReferredDriversAction(1, 10)
                );
            }}
        />
        </Flex>
    );
};

export default Referrals;